// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Badges/style.css
 ** module id = 627
 ** module chunks = 0
 **/